import { render, staticRenderFns } from "./towork-dialog.vue?vue&type=template&id=ad6bcde0&"
import script from "./towork-dialog.vue?vue&type=script&lang=js&"
export * from "./towork-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "towork-dialog.vue"
export default component.exports